<template>
  <LayoutGroup>
    <!-- 双层卡片 -->
    <Motion
      class="size-full cursor-pointer transition-colors relative overflow-hidden text-white bg-default active:brightness-90"
      layout
      @click="useLocalePush(model.path)"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
      @touchmove.passive="isHover = true"
      @touchend="isHover = false"
    >
      <UIcon
        v-show="useCheckOutLink(model.path)"
        name="mdi:external-link"
        class="absolute z-1 top-4 right-4 text-xl"
      />
      <!-- 顶层文字盒子 -->
      <Motion
        layout
        :class="[
          'absolute z-1 w-full bottom-0 p-4 bg-black/60 mask-t-from-60% mask-t-to-transparent pt-10',
          '[&_a]:hover:underline [&_a]:hover:text-primary',
        ]"
      >
        <!-- 始终显示的文本容器 -->
        <Motion layout>
          <!-- 时间 -->
          <NuxtTime
            v-if="model.created"
            :datetime="model.created"
            :locale="locale"
            year="numeric"
            month="long"
            day="numeric"
            class="lg:text-md text-sm opacity-80 line-clamp-1 m-0"
          />
          <!-- 标题 -->
          <a
            :class="[
              'lg:text-2xl text-xl font-semibold line-clamp-2 mt-1',
              isHover ? 'text-primary' : '',
            ]"
          >
            {{ model.title }}
          </a>
        </Motion>
        <!-- 正文容器-悬浮后上升 -->
        <Motion
          v-if="isHover"
          layout
          :initial="{ opacity: 0 }"
          :animate="{ opacity: 1 }"
          :transition="{ delay: 0.2 }"
        >
          <!-- 正文 -->
          <a class="text-sm m-0 line-clamp-3 opacity-90 mt-1">
            {{ model.description }}
          </a>
        </Motion>
      </Motion>

      <!-- 背景图层容器 -->
      <img
        :class="[
          'absolute size-full object-cover duration-500',
          isHover ? 'scale-110' : 'scale-100',
        ]"
        :src="model.bannerImg"
        draggable="false"
        alt="Focus Card"
        loading="lazy"
      />
    </Motion>
  </LayoutGroup>
</template>

<script setup lang="ts">
  import type { ArticlesEnCollectionItem } from '@nuxt/content'

  const { locale } = useI18n()
  const isHover = ref(false)

  const model = defineModel<ArticlesEnCollectionItem>({
    required: true,
  })
</script>
